export default function() {
  return {
    galleryList: [],
    totalItems : 0,
    page: 1,
    limit: 8,
    statusUpdateGallery: [],
    statusInsertGallery: [],
    statusDelGallery: []
  }
}
